import { jsx as _jsx } from "react/jsx-runtime";
import { CloudQueueRounded, ForwardToInboxRounded, PhoneForwardedRounded, } from '@mui/icons-material';
import branding from 'shared/app/model/branding';
export const tariff_configs = [
    {
        key: 'mb',
        title: 'Интернет',
        icon: _jsx(CloudQueueRounded, { color: "info" }),
        unit: 'МБ',
        hint: `Объем трафика для передачи данных.`,
    },
    {
        key: 'sms',
        title: 'Исходящие СМС',
        icon: _jsx(ForwardToInboxRounded, { sx: { color: 'neutral_dark.light' } }),
        unit: 'сообщений',
        hint: `СМС сообщения, отправляемые с устройства ${branding.name} владельцу.`,
    },
    {
        key: 'calls',
        title: 'Исходящие звонки',
        icon: _jsx(PhoneForwardedRounded, { color: "success" }),
        unit: 'минут',
        hint: `Звонки с устройства владельцу прибора ${branding.name}.`,
    },
];
